import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { KeyRoundIcon, PencilIcon, Trash2Icon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import Badge, { BadgeType } from '../Badge/Badge'
import styled from 'styled-components'
import { Style } from '../../styles'
import { UserWorkspaceSettingStatus } from '../../types'

const Subheading = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;

	@media screen and (max-width: ${Style.breakpoints.SMALL}) {
		flex-direction: column;
	}
`

const SubheadingBadge = styled.div<{ $flush?: boolean }>`
	margin-left: ${props => props.$flush ? '0' : Style.spacing.x1};

	@media screen and (max-width: ${Style.breakpoints.SMALL}) {
		margin-left: 0;
		margin-top: ${Style.spacing.x1};
	}
`

interface IProps {
	name?: string
	subheading?: string
	role?: string
	status?: UserWorkspaceSettingStatus
	badge?: { type: BadgeType, text: string }
	actions?: React.ReactNode
	onCredentialsClick?: () => void
	onEditClick?: () => void
	onDeleteClick?: () => void
}

const MemberItem = (props: IProps) => {
	const { t } = useTranslation()
	const {
		name,
		subheading,
		role,
		status,
		badge,
		actions,
		onCredentialsClick,
		onEditClick,
		onDeleteClick,
	} = props

	const statusBadge = status
		? { type: (status === UserWorkspaceSettingStatus.ACTIVE ? 'success' : 'warning') as BadgeType, text: t(`UserWorkspaceSettingStatus::${status}`) }
		: badge

	return (
		<div className='member-item'>
			<div className='member-item-wrapper'>
				<div className='member-item-avatar'>
					{name.substring(0, 1).toUpperCase()}
				</div>

				<div className='member-item-content'>

					<div className='member-item-content-heading'>
						{name && <div className='member-item-content-heading-name'>
							{name}
						</div>}

						{role && <div className='member-item-content-heading-role'>
							{role}
						</div>}
					</div>

					{(subheading || statusBadge) && <div className='member-item-content-subheading'>
						<Subheading>
							{subheading}

							{statusBadge && <SubheadingBadge $flush={!subheading}>
								<Badge type={statusBadge.type} text={statusBadge.text} />
							</SubheadingBadge>}
						</Subheading>
					</div>}
				</div>

				<div className='member-item-action gap-2'>
					{actions}

					{onCredentialsClick && <Button variant='outline' size='sm' onClick={onCredentialsClick}>
						<KeyRoundIcon data-icon='inline-start' />
						{t('MemberItem::Send login details')}
					</Button>}

					{onEditClick && <Button variant='outline' size='sm' onClick={onEditClick}>
						<PencilIcon data-icon='inline-start' />
						{t('MemberItem::Edit')}
					</Button>}

					{onDeleteClick && <Button variant='destructive' size='sm' onClick={onDeleteClick}>
						<Trash2Icon data-icon='inline-start' />
						{t('MemberItem::Remove')}
					</Button>}
				</div>
			</div>
		</div>
	)
}

export default MemberItem